import api from './api';

export const authService = {
  login: async (email, pin) => {
    const response = await api.post('/auth/login', { email, pin });
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.employe));
      window.dispatchEvent(new CustomEvent('auth-change', { detail: response.data.employe }));
    }
    return response.data;
  },

  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.dispatchEvent(new CustomEvent('auth-change', { detail: null }));
  },

  getCurrentUser: () => {
    try {
      const userStr = localStorage.getItem('user');
      if (userStr) {
        const user = JSON.parse(userStr);
        if (user && user.role) return user;
      }
      // Fallback d'affichage uniquement : l'autorisation réelle reste vérifiée par l'API.
      const token = localStorage.getItem('token');
      if (token) {
        const parts = token.split('.');
        if (parts.length === 3) {
          const base64Url = parts[1];
          const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
          let jsonPayload = '';
          try {
            jsonPayload = decodeURIComponent(
              atob(base64)
                .split('')
                .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                .join('')
            );
          } catch (err) {
            jsonPayload = atob(base64);
          }
          const decoded = JSON.parse(jsonPayload);
          if (decoded && (decoded.id || decoded.email)) {
            const userObj = {
              id: decoded.id,
              email: decoded.email || '',
              nom: decoded.nom || '',
              prenom: decoded.prenom || '',
              role: decoded.role || 'EMPLOYE',
              departement: decoded.departement || ''
            };
            localStorage.setItem('user', JSON.stringify(userObj));
            return userObj;
          }
        }
      }
      return null;
    } catch (e) {
      return null;
    }
  },

  verify: async () => {
    const response = await api.get('/auth/verify');
    return response.data;
  },

  // Auto-inscription publique (sans authentification)
  register: async (data) => {
    const response = await api.post('/auth/inscription', data);
    return response.data;
  }
};

export const employeService = {
  getAll: async () => {
    const response = await api.get('/employes');
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/employes/${id}`);
    return response.data;
  },

  create: async (employe) => {
    const response = await api.post('/employes', employe);
    return response.data;
  },

  update: async (id, employe) => {
    const response = await api.put(`/employes/${id}`, employe);
    return response.data;
  },

  updateMe: async (employe) => {
    const response = await api.put('/employes/me', employe);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/employes/${id}`);
    return response.data;
  },

  anonymize: async (id) => {
    const response = await api.put(`/employes/${id}/anonymize`);
    return response.data;
  },

  activer: async (id) => {
    const response = await api.put(`/employes/${id}/activer`);
    return response.data;
  },

  resetPin: async (id, newPin) => {
    const response = await api.put(`/employes/${id}/reset-pin`, { newPin });
    return response.data;
  },

  changeMyPin: async (oldPin, newPin) => {
    const response = await api.put('/employes/me/change-pin', { oldPin, newPin });
    return response.data;
  },

  import: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.post('/employes/import', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  downloadTemplate: async () => {
    const response = await api.get('/employes/import-template', { responseType: 'blob' });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'gabarit-import-employes.xlsx');
    document.body.appendChild(link);
    link.click();
    link.remove();
  }
};

export const siteService = {
  getAll: async () => {
    const response = await api.get('/sites');
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/sites/${id}`);
    return response.data;
  },

  create: async (site) => {
    // Ne PAS définir Content-Type pour FormData - le navigateur le fait automatiquement avec le boundary
    const response = await api.post('/sites', site);
    return response.data;
  },

  update: async (id, site) => {
    // Ne PAS définir Content-Type pour FormData - le navigateur le fait automatiquement avec le boundary
    const response = await api.put(`/sites/${id}`, site);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/sites/${id}`);
    return response.data;
  },

  getQRCode: async (id) => {
    const response = await api.get(`/sites/${id}/qrcode`);
    return response.data;
  },

  getQRCodeUrl: async (id) => {
    const response = await api.get(`/sites/${id}/qrcode-url`);
    return response.data;
  }
};

export const pointageService = {
  create: async (pointage) => {
    const response = await api.post('/pointages', pointage);
    return response.data;
  },

  getAll: async (filters) => {
    const response = await api.get('/pointages', { params: filters });
    return response.data;
  },

  getByEmploye: async (employeId) => {
    const response = await api.get(`/pointages/employe/${employeId}`);
    return response.data;
  },

  getStats: async () => {
    const response = await api.get('/pointages/stats');
    return response.data;
  }
};
